(function () {
  var REVIEW_LIST_SELECTOR = '#reviewslist .kl_reviews__list_container';
  var REVIEWS_SECTION_SELECTORS = [
    '#klaviyo-product-reviews-wrapper',
    '#fulfilled-reviews-all',
    '[id*="klaviyo_reviews_product_reviews"]',
  ].join(', ');
  var BADGE_TRIGGER_SELECTOR = '[data-scroll-to-klaviyo-reviews]';
  var DEDUPE_DELAY_MS = 150;
  var SCROLL_OFFSET = 24;

  var dedupeTimer;

  function getReviewKey(item) {
    var author = item.querySelector('.kl_reviews__review__author div');
    var content = item.querySelector('.kl_reviews__review__content');
    var time = item.querySelector('.kl_reviews__review__timestamp');

    return [
      author ? author.textContent.trim() : '',
      content ? content.textContent.trim() : '',
      time ? time.textContent.trim() : '',
    ].join('|');
  }

  function dedupeReviews(scope) {
    var root = scope && scope.querySelector ? scope : document;
    var container = root.querySelector
      ? root.matches && root.matches(REVIEW_LIST_SELECTOR)
        ? root
        : root.querySelector(REVIEW_LIST_SELECTOR)
      : null;

    if (!container) return;

    var seen = new Set();

    container.querySelectorAll('.kl_reviews__review_item').forEach(function (item) {
      var key = getReviewKey(item);

      if (seen.has(key)) {
        item.remove();
        return;
      }

      seen.add(key);
    });
  }

  function scheduleDedupe(scope) {
    clearTimeout(dedupeTimer);
    dedupeTimer = setTimeout(function () {
      dedupeReviews(scope);
    }, DEDUPE_DELAY_MS);
  }

  function observeReviewsList(list) {
    if (!list || list.dataset.klReviewsDedupeObserved) return;

    list.dataset.klReviewsDedupeObserved = 'true';
    dedupeReviews(list);

    if (typeof MutationObserver === 'undefined') return;

    new MutationObserver(function () {
      dedupeReviews(list);
      scheduleDedupe(list);
    }).observe(list, { childList: true, subtree: true });
  }

  function getReviewsSection() {
    return document.querySelector(REVIEWS_SECTION_SELECTORS);
  }

  function scrollToReviews(attempt) {
    var target = getReviewsSection();

    if (!target) {
      if ((attempt || 0) < 20) {
        setTimeout(function () {
          scrollToReviews((attempt || 0) + 1);
        }, 100);
      }
      return;
    }

    if (!target.id) {
      target.id = 'product-reviews';
    }

    var headerOffset =
      parseInt(
        getComputedStyle(document.documentElement).getPropertyValue('--header-height'),
        10
      ) || 0;
    var top = target.getBoundingClientRect().top + window.scrollY - headerOffset - SCROLL_OFFSET;

    window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
  }

  function initScrollToReviews() {
    document.addEventListener('click', function (e) {
      if (!e.target.closest(BADGE_TRIGGER_SELECTOR)) return;
      scrollToReviews(0);
    });
  }

  function init() {
    initScrollToReviews();
    observeReviewsList(document.querySelector('#reviewslist'));

    if (typeof MutationObserver === 'undefined') return;

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;

          if (node.id === 'reviewslist') {
            observeReviewsList(node);
            return;
          }

          if (node.querySelector) {
            observeReviewsList(node.querySelector('#reviewslist'));
          }
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
